import React, { useEffect, useState } from "react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "./ui/carousel";

/**
 * Renders children as a grid on md+ screens and as a carousel on mobile.
 * Props:
 *  - items: array
 *  - renderItem: (item, idx) => ReactNode
 *  - gridCols: tailwind classes for md+ grid (default 3 cols)
 *  - mobileBasis: carousel basis for mobile (default 85%)
 */
export const SectionCarousel = ({
  items,
  renderItem,
  gridCols = "md:grid-cols-2 lg:grid-cols-3",
  mobileBasis = "basis-[85%]",
  className = "",
}) => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 767px)");
    const onChange = () => setIsMobile(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  if (!isMobile) {
    return (
      <div className={`grid grid-cols-1 gap-5 ${gridCols} ${className}`}>
        {items.map((item, i) => (
          <React.Fragment key={i}>{renderItem(item, i)}</React.Fragment>
        ))}
      </div>
    );
  }

  return (
    <Carousel opts={{ align: "start", loop: false }} className={`relative ${className}`}>
      <CarouselContent className="-ml-4">
        {items.map((item, i) => (
          <CarouselItem key={i} className={`pl-4 ${mobileBasis}`}>
            {renderItem(item, i)}
          </CarouselItem>
        ))}
      </CarouselContent>
      <div className="mt-4 flex justify-end gap-2">
        <CarouselPrevious className="relative left-0 top-0 translate-y-0" />
        <CarouselNext className="relative right-0 top-0 translate-y-0" />
      </div>
    </Carousel>
  );
};

export default SectionCarousel;
